import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { PlainGalleryConfig, Description, PlainGalleryStrategy, DescriptionStrategy, AdvancedLayout, Image } from '@ks89/angular-modal-gallery';
import { Room } from '../room-availability-v2/Room.model';
import { ResortInventory, ResortImageType, ResortImage } from '../../models/presentation.model';
import { ImageService } from '../../services/image.service';
import { ResortImageExtension } from '../../models/browser.model';
import { Core, LabelNames } from '../../shared/core/ovs.core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BenefitAmount } from '../ocean-upgrade/benefit-amount.model';
import { DisplayOptionsService } from '../../services/display-options.service';

@Component({
  selector: 'room-card',
  templateUrl: './room-card.component.html',
  styleUrls: ['./room-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RoomCardComponent implements OnInit, AfterViewInit {

  private modalRef: NgbModalRef;

  @Input() room: Room;
  @Input() inventory: ResortInventory;
  @Input() isGrid: boolean;
  @Input() imagesDisabled: boolean;
  @Input() noImages: boolean; //Disables all room images for standard listings
  @Input() showPricePerDay: boolean;
  @Input() showRewardPerDay: boolean;
  @Input() isPreferred: boolean;

  public get memberRate(): number {
    return this.room.inventory.getMemberRate(this.showPricePerDay);
  }

  public get hasEarnReward(): boolean {
    return this.room.hasEarnReward;
  }

  public get hasOnlineBooking(): boolean {
    return Core.current.currentConfiguration.HasOnlineBooking;
  }

  public get isAgent(): boolean {
    return Core.current.currentConfiguration.IsAgent;
  }

  public get showPricing(): boolean {
    return Core.current.currentConfiguration.ShowPricing;
  }

  public get benefitAmount(): BenefitAmount {
    return <BenefitAmount>{ withCurrentMembership: this.room.discountedPricingWithRewards.reward, withUpgradedMembership: this.room.upgradePricing.reward };
  }
  @Output() book: EventEmitter<any> = new EventEmitter();
  @Output() bookWithUpgrade: EventEmitter<any> = new EventEmitter();


  public get rewardTypeLabel(): string{
    return this.displayOptions.getLabel(LabelNames.VacationCash);
  }

  constructor(
    private imageService: ImageService,
    private modalService: NgbModal,
    private displayOptions: DisplayOptionsService
  ) {
    // super();
  }

  ngOnInit() {
    this.roomImages = this.getRoomImages();
  }

  ngAfterViewInit(): void {
  }

  public getImageUrl() {
    let url = this.imageService.getImageUrl(this.imageService.getImagesByType(this.room.inventory.unitTypeImageList, [ResortImageType.UnitType])[0])
    return url;
  }
  //Temp Date Format placeholder
  today: number = Date.now();

  //Image Gallery Configs
  customPlainGalleryRowConfig: PlainGalleryConfig = {
    strategy: PlainGalleryStrategy.CUSTOM,
    layout: new AdvancedLayout(-1, true),
  };

  customDescriptionHidden: Description = {
    strategy: DescriptionStrategy.ALWAYS_HIDDEN,
    customFullDescription: 'Custom description of the current visible image'
  };

  openImageModalRow(i: number) {
    // console.log('Opening modal gallery from custom plain gallery row, with image: ', image);
    //   const index: number = this.getCurrentIndexCustomLayout(image, this.roomImages);
    this.customPlainGalleryRowConfig = Object.assign({}, this.customPlainGalleryRowConfig,
      { layout: new AdvancedLayout(i, true) });
  }

  private getCurrentIndexCustomLayout(image: Image, roomImages: Image[]): number {
    return image ? roomImages.indexOf(image) : -1;
  }

  public onBookClicked(): void {
    if(this.modalRef) {this.modalRef.dismiss();}
    this.book.emit(this.room.inventory);
  }

  public onUpgradeClicked(): void {
    if(this.modalRef) {this.modalRef.dismiss();}
    this.bookWithUpgrade.emit(this.room.inventory);
  }

  public onCloseModalClicked(): void {
    this.modalRef.dismiss();
  }

  public learnMore(): void {
    if (!Core.current.currentConfiguration.IsAgent) {
      console.log(Core.current.currentConfiguration.SubscriberLink);
      if (Core.current.currentConfiguration.SubscriberLink && Core.current.currentConfiguration.SubscriberLink != '') {
        window.location.replace(Core.current.currentConfiguration.SubscriberLink);
      } else {
        window.location.replace('https://www.oceanrewards.com/upgrade/');
      }
    }
    else {
      window.location.replace('https://www.oceanrewards.com/agent/upgrade');
    }
  }

  public openUpgradeModal(oceanUpgradeModal) {
    this.modalRef = this.modalService.open(oceanUpgradeModal, { size: 'lg', windowClass: 'upgrade-modal' });
    // this.learnMore()
  }

  private getRoomImages(): Image[] {
    let images: Image[] = new Array<Image>();
    let resortImages: ResortImage[] = new Array<ResortImage>();
    resortImages = this.imageService.getImagesByType(this.room.inventory.unitTypeImageList, [ResortImageType.UnitType]);

    let i: number = 0;
    resortImages.forEach(x => {
      let image: Image = new Image(i,
        {
          img: this.imageService.getImageUrl(x),
        }
      );
      images.add(image); i = i + 1;
    });
    return images;
  }
  // Mock Room Images
  roomImages: Image[] = [];

  // Mock Room Images
  //   roomImages: Image[] = [
  //     new Image(0, {
  //       img: 'https://ovsmarketingstorage.blob.core.windows.net/ng-resortui/5668/5668_15_unittype01.jpg',
  //     }),
  //     new Image(1, {
  //       img: 'https://ovsmarketingstorage.blob.core.windows.net/ng-resortui/5668/5668_15_unittype02.jpg',
  //     }),
  //     new Image(
  //       2,
  //       {
  //         img: 'https://ovsmarketingstorage.blob.core.windows.net/ng-resortui/5763/5763_15_unittype01.jpg',
  //         description: 'Description 3',
  //       },
  //       {
  //         img: 'https://ovsmarketingstorage.blob.core.windows.net/ng-resortui/5763/5763_15_unittype01.jpg',
  //         title: 'custom title 2',
  //         alt: 'custom alt 2',
  //         ariaLabel: 'arial label 2'
  //       }
  //     ),
  //     new Image(3, {
  //       img: 'https://ovsmarketingstorage.blob.core.windows.net/ng-resortui/5763/5763_15_unittype02.jpg',
  //       description: 'Description 4',
  //     }),
  //     new Image(4, { img: 'https://ovsmarketingstorage.blob.core.windows.net/ng-resortui/5763/5763_15_unittype04.jpg' },
  //       { img: 'https://ovsmarketingstorage.blob.core.windows.net/ng-resortui/5763/5763_15_unittype04.jpg' })
  //   ];

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/room-card/room-card.component.ts